import React from "react";
import ConnectedAccountModalHeaderImage from "./ConnectedAccountModalHeaderImage";
import ConnectedAccountModalHeaderText from "./ConnectedAccountModalHeaderText";
import ConnectedAccountPageActivateAccountBadge from "./ConnectedAccountPageActivateAccountBadge";
import ConnectedPreviousFundraiserMessage from "./ConnectedPreviousFundraiserMessage";
import "./AccountModalHeader.scss";

const AccountModalHeader = () => (
    // Cols and grids are added inside optional elements so they are removed
    // from the UI when those elements are not rendered
    <div className="account-modal-header">
        <ConnectedAccountPageActivateAccountBadge />
        <ConnectedAccountModalHeaderImage />
        <ConnectedAccountModalHeaderText />
        <ConnectedPreviousFundraiserMessage />
    </div>
);
export default AccountModalHeader;
